// extracted by mini-css-extract-plugin
export default {"price":"AddCowrie_price__jT6v5","card":"AddCowrie_card__8LW52","progress":"AddCowrie_progress__VnhfC","progress-bar":"AddCowrie_progress-bar__WLmhl","group":"AddCowrie_group__P0uv2"};